import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { WelcomeNavbar } from '@shared/components/navigation/components/welcome-navbar/welcome-navbar';

@Component({
  selector: 'app-welcome',
  imports: [WelcomeNavbar, NgIcon],
  templateUrl: './welcome.html',
  styleUrl: './welcome.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Welcome {
  socialMedias = signal([
    {
      name: 'Instagram',
      icon: 'ionLogoInstagram',
      url: 'https://www.instagram.com/gwm_ve/',
    },
    {
      name: 'TikTok',
      icon: 'ionLogoTiktok',
      url: 'https://www.tiktok.com/@gwm_ve',
    },
    {
      name: 'Facebook',
      icon: 'ionLogoFacebook',
      url: 'https://www.facebook.com/people/GWM-Venezuela/61559902326453/',
    },
  ]);
}
